export const HTTP_DEFAULT_TIMEOUT = 3000;

/**
 * Per-request timeout for paying a booking.
 * Paying a booking runs the end-to-end Navitaire + internal workflow, which
 * regularly outlives the default 3s timeout. A longer window lets most payments
 * return normally instead of aborting prematurely; the frontend recovery poll
 * (see useBookingConfirmation) covers the rest.
 */
export const BOOKING_PAYMENT_TIMEOUT_MS = 35000;

/** The threshold for checking if the token needs to be refreshed */
export const CHECK_REFRESH_TOKEN_THRESHOLD_SECONDS = 30;
/** The time before the token expires to refresh the token */
export const TOKEN_REFRESH_LEEWAY_SECONDS = CHECK_REFRESH_TOKEN_THRESHOLD_SECONDS;